export default __webpack_public_path__ + "static/media/cursor.ea5cfd33.svg";